import React from 'react';
import checkmark from '../../assets/img/ico/checkmark.svg';
import '../../assets/css/mission-accepted-notification.css';
import { HashLink as Link } from "react-router-hash-link";

export default function AcceptedMissionNotification() {

    return (
        <section className={"accepted-mission-section"}>
            <Link className={"btn empty"} to="/dashboard-interim">Revenir au tableau de bord</Link>
        <div className="accepted-mission-notification">
            <img src={checkmark} alt={"checkmark"} />
            <h2>Félicitations !</h2>
            <h2>Vous avez accepté la mission</h2>
            <p>Voici les prochaines étapes pour finaliser votre engagement.</p>
            <div>
            <p>Un représentant de l’agence vous contactera sous 24h. </p>
            <p>Vous recevrez un e-mail avec toutes les informations.</p>
            <p>Un point de rencontre sera communiqué avant le début de la mission.</p>
            </div>
            <Link className={"btn fill green"} to="/mission-list">Voir mes missions</Link>
            <Link className={"btn empty"} to="/dashboard-interim">Annuler</Link>
        </div>
        </section>
    );

}